import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const EthicalHealthDataviewStyled = styled.div`
  padding: 20px;
  overflow-x: auto;
  width: 100%;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
`;

export const HeroMetricContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const DonutContainer = styled.div`
  width: 300px;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
`;

export const BarChartContainer = styled.div`
  width: 100%;
  margin-left: 20px;
`;

export const DonutAndBarHorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InsightsDisclaimer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 20px 0 0 0;

  p {
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
    color: ${(props) => props.theme.atlas.semantic.color.type.muted};
    margin: 0;
  }
`;
